import React from 'react'
import Link from './Link'

export default ({
  to,
  children,
  fullWidth = false,
  className = '',
  marginClass = 'mt-8',
}) => {
  const display = fullWidth ? 'block' : 'inline-block'
  return (
    <Link
      className={`${display} ${marginClass} px-4 py-1 bg-theme font-body text-theme-white border-0 border-r-4 border-b-4 border-theme-light  hover:bg-theme-light focus-within:bg cursor-pointer ${className}`}
      to={to}
    >
      {children}
    </Link>
  )
}
